import { SITE } from "@/lib/site";

const LINKS = [
  { href: "#services", label: "Formules" },
  { href: "#faq", label: "FAQ" },
  { href: "#contact", label: "Contact" },
  { href: "#mentions", label: "Mentions légales" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#111111] text-white/70 py-14 sm:py-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-sm bg-[#E8611A] text-white font-display font-extrabold text-sm">
                DA
              </span>
              <span className="font-display font-bold text-white text-lg">
                {SITE.brand}
              </span>
            </div>
            <p className="text-white/55 text-sm max-w-sm leading-relaxed">
              {SITE.slogan} Assistant administratif externalisé pour artisans
              du BTP — {SITE.zone}.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-white font-display font-semibold text-sm uppercase tracking-wider mb-4">
              Navigation
            </h4>
            <ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-white/55 hover:text-[#E8611A] text-sm transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-white font-display font-semibold text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  className="text-white/55 hover:text-[#E8611A] transition-colors"
                >
                  {SITE.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${SITE.phone.replace(/\s/g, "")}`}
                  className="text-white/55 hover:text-[#E8611A] transition-colors"
                >
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={SITE.calendly}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/55 hover:text-[#E8611A] transition-colors"
                >
                  Prendre rendez-vous
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © {SITE.year} {SITE.brand} — Tous droits réservés.
          </p>
          <p className="text-white/40 text-xs">
            Site réalisé avec exigence pour les artisans du BTP.
          </p>
        </div>
      </div>
    </footer>
  );
}
